import { OCR_MONTHLY_LIMIT, OCR_TRIAL_LIFETIME } from '../constants/ocrPlans';

export function canAccessOcr(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;
  const slug = (user.currentPlan?.slug || '').toLowerCase();
  if (slug === 'profesional' || slug === 'empresarial') return true;
  if (slug === 'basico') return true;
  const features = user.unlockedFeatures || user.currentPlan?.features || {};
  return Boolean(features.ocrTickets);
}

export function canBuyOcrPacks(user) {
  if (!user) return false;
  const slug = (user.currentPlan?.slug || '').toLowerCase();
  return slug === 'profesional' || slug === 'empresarial';
}

export function getOcrMonthlyLimit(slug) {
  const s = String(slug || 'basico').toLowerCase();
  return OCR_MONTHLY_LIMIT[s] ?? 0;
}

export { OCR_TRIAL_LIFETIME, OCR_MONTHLY_LIMIT };
